import { render, staticRenderFns } from "./StudentProducts.vue?vue&type=template&id=4cb2ab45&scoped=true&"
import script from "./StudentProducts.vue?vue&type=script&lang=js&"
export * from "./StudentProducts.vue?vue&type=script&lang=js&"
import style0 from "./StudentProducts.vue?vue&type=style&index=0&id=4cb2ab45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2ab45",
  null
  
)

export default component.exports